import { Box, Grid } from '@mui/material';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';

import useMedia from '../../hooks/useMedia';
import DocumentGroupList from '../../components/lists/DocumentGroupList';
import DocumentsList from '../../components/lists/DocumentList';
import useDocuments from '../../hooks/useDocuments';

interface Props {
  initialyShowDocs?: boolean;
  onlyUnreadDocs?: boolean;
  title?: string;
  documentGroups?: string[];
}

const Documents: FC<Props> = observer(props => {
  const { initialyShowDocs, onlyUnreadDocs, title, documentGroups } = props;
  const isMobile = useMedia('md');

  const {
    documentsFromTiles,
    selectedDocumentGroup,
    setSelectedDocumentGroup,
    getCurrentDocumentsByName,
  } = useDocuments(initialyShowDocs, onlyUnreadDocs);

  let filteredGroups;
  if (documentGroups) {
    filteredGroups = documentsFromTiles.filter(group =>
      documentGroups.includes(group.tileTitle),
    );
  }

  return (
    <Grid id="documents" item sm={12} sx={{ width: '100%' }}>
      <Grid container p={2}>
        <Grid item xs={12} md={6}>
          <DocumentGroupList
            title={title || 'Dokumente'}
            hasArrow={!isMobile && selectedDocumentGroup !== null}
            documentGroups={filteredGroups || documentsFromTiles}
            seleced={selectedDocumentGroup}
            setSelected={setSelectedDocumentGroup}
          />
        </Grid>
        {selectedDocumentGroup && (
          <Grid item xs={12} md={6}>
            <Box sx={{ marginTop: isMobile ? 0 : 20 }}>
              <DocumentsList
                documents={
                  getCurrentDocumentsByName(
                    documentsFromTiles,
                    selectedDocumentGroup,
                  ) || []
                }
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
});

export default Documents;
